// extracted by mini-css-extract-plugin
module.exports = {"contact":"ContactPerson_contact__1I6Cp"};